import EmptyStateContent from './EmptyStateContent';
export default EmptyStateContent;
